import i18n from "../../i18n";

export function passwordValidator(password) {
    if (!password) return i18n.t('validation_password_required')
    if (password.length < 6) return i18n.t('validation_password_min_length')
  return ''
}
